import './DimensionsPicker.scss';
import { AddCustomDimension } from '@Components/AddCustomDimension';
import { Appearance, Size } from '@Components/designConstants';
import { Button } from '@Components/Button';
import { DIMENSION_OPTIONS } from './generate-view-constants';

interface DimensionsPickerProps {
  dimensionsMap: Record<string, boolean>;
  onChange: (dimensionsMap: Record<string, boolean>) => void;
}

export const DimensionsPicker = ({ dimensionsMap, onChange }: DimensionsPickerProps) => (
  <div className='dimensions-container'>
    <div className='dimensions-grid'>
      {[
        ...DIMENSION_OPTIONS,
        // Custom dimensions added below don't have a grid button of their own otherwise, so
        // a selected one would appear to silently vanish.
        ...Object.keys(dimensionsMap)
          .filter(value => !DIMENSION_OPTIONS.some(opt => opt.value === value))
          .map(value => ({ label: value, value }))
      ].map(({ value }) => (
        <Button
          key={value}
          size={Size.SM}
          appearance={dimensionsMap[value] ? Appearance.FILLED : Appearance.OUTLINED}
          onClick={() => onChange({ ...dimensionsMap, [value]: !dimensionsMap[value] })}
        >
          {value}
        </Button>
      ))}
    </div>
    <AddCustomDimension
      existingValues={Object.keys(dimensionsMap)}
      onAdd={value => onChange({ ...dimensionsMap, [value]: true })}
    />
  </div>
);
